// Shared label / help / error chrome for every field renderer.
//
// Centralising it here is what makes the whole form set visually consistent:
// a change to label weight or error colour lands on every input in every
// vertical at once, and a new field type gets the house style for free.
import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * @param {Object} props
 * @param {string} [props.label]
 * @param {boolean} [props.required]
 * @param {string} [props.help]
 * @param {string} [props.error]
 * @param {string} [props.htmlFor]
 * @param {React.ReactNode} props.children
 * @param {Object} [props.sx]
 */
const FieldFrame = ({ label, required, help, error, htmlFor, children, sx }) => (
  <Box sx={{ mt: 2, ...sx }}>
    {label && (
      <Typography
        component="label"
        htmlFor={htmlFor}
        variant="subtitle2"
        sx={{
          display: "block",
          color: "#3d322b",
          fontWeight: 600,
          fontSize: "0.9375rem",
          letterSpacing: 0.1,
          mb: 0.75,
        }}
      >
        {label}
        {required && (
          <Box component="span" aria-hidden sx={{ color: "#C9A777", ml: 0.5 }}>
            *
          </Box>
        )}
      </Typography>
    )}

    {children}

    {(error || help) && (
      <Typography
        variant="caption"
        role={error ? "alert" : undefined}
        sx={{
          display: "block",
          mt: 0.5,
          fontWeight: 500,
          fontSize: "0.8125rem",
          letterSpacing: 0.1,
          color: error ? "#d4575a" : "#7B6E66",
        }}
      >
        {error || help}
      </Typography>
    )}
  </Box>
);

export default FieldFrame;
